export default {
  SET_CLIENTES: (state, payload) => {
    state.clientes = payload
  },
  SET_CLIENTES_FILTROS: (state, payload) => {
    state.clientesFiltros = payload
  },
  SET_TOTAL_CLIENTES: (state, payload) => {
    state.totalClientes = payload
  },
  SET_CLIENTES_EXPORT: (state, payload) => {
    state.clientesExport = payload
  },
  SET_CLIENTES_FILTERS_EXPORT: (state, payload) => {
    state.clientesFiltersExport = payload
  }
}